import {
  collection,
  onSnapshot,
  query,
  orderBy,
  where
} from "firebase/firestore";
import { db } from "../../Firebase";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import StatusSelect from "../../components/StatusSelect";
import AdminNav from "../../components/AdminNav";

export default function AdminLeads() {
  const [leads, setLeads] = useState([]);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const statusFilter = searchParams.get("status");

  useEffect(() => {
    let q = query(
      collection(db, "leads"),
      orderBy("createdAt", "desc")
    );

    if (statusFilter) {
      q = query(
        collection(db, "leads"),
        where("status", "==", statusFilter),
        orderBy("createdAt", "desc")
      );
    }

    const unsub = onSnapshot(q, (snap) => {
      const data = snap.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setLeads(data);
    });

    return () => unsub();
  }, [statusFilter]);

  return (
    <div className="admin-page">
      <AdminNav />
      <h1>
        Leads
        {statusFilter && (
          <span style={{ fontSize: "0.9rem", color: "#666" }}>
            {" "}
            — {statusFilter.replace("_", " ")}
          </span>
        )}
      </h1>

      {statusFilter && (
        <button
            onClick={() => navigate("/admin/leads")}
            style={{ marginBottom: "1rem" }}
        >
            Clear filter
        </button>
        )}

      {leads.length === 0 ? (
        <p>No leads found.</p>
      ) : (
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Company</th>
              <th>Name</th>
              <th>Status</th>
            </tr>
          </thead>

          <tbody>
            {leads.map((lead) => (
              <tr
                key={lead.id}
                onClick={() => navigate(`/admin/leads/${lead.id}`)}
                style={{ cursor: "pointer" }}
              >
                <td>
                  {lead.createdAt
                    ? lead.createdAt.toDate().toLocaleDateString()
                    : "—"}
                </td>
                <td>{lead.company || "—"}</td>
                <td>{lead.name}</td>
                <td>
                  <StatusSelect
                    leadId={lead.id}
                    currentStatus={lead.status}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

